<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Rom</h2>
    </v-flex>
    <v-container>
      <v-layout row wrap align-content-center>
        <template v-for="(item, index) in stepValues.roomList">
          <v-flex xs12 sm6 md4 lg3 :key="index" class="mb-2 p-2">
            <Room
              :room="item"
              :index="index"
              @delete-room="deleteRoom"
              @edit-room="editRoom"
              :key="index"
              :editText="editRoomButton"
            ></Room>
          </v-flex>
        </template>
        <v-select
          label="Boligtype"
          v-model="stepValues.houseType"
          :items="houseTypeList"
          item-text="name"
          return-object
          @change="selectHouseType"
          v-if="stepValues.roomList.length == 0"
        ></v-select>
      </v-layout>
    </v-container>
    <v-flex xs12 class="mb-5">
      <v-btn block color="success" :dark="protocol.dark" v-on:click.stop="openEditRoomDialog">Legg til nytt rom</v-btn>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
    <EditRoom
      :dialog="editRoomDialog"
      @update-fields="updateFields"
      :selectedRoom="selectedRoom"
      @close-edit-room-dialog="closeEditRoomDialog"
      :cleaningEnabled="cleaningEnabled"
      :config="config"
      @error="error"
    ></EditRoom>
  </div>
</template>

<script>
import Room from "./Rooms/Room.vue";
import EditRoom from "./Rooms/EditRoom.vue";
import RoomObject from "../../models/room";
import HOUSETYPES from "../../models/houseTypes";
import HouseTypeFactory from "../../models/houseTypeFactory";
import step from "../../mixins/step";
import store from '../../store/store';
export default {
  mixins: [step],
  data() {
    return {
      editRoomDialog: false,
      selectedRoom: new RoomObject("Bedroom"),
      houseTypes: HOUSETYPES,
    };
  },
  components: { Room, EditRoom },
  computed: {
    houseTypeList: {
      get() {
        let arr = [];
        for (var propertyName in this.houseTypes) {
          let hType = HouseTypeFactory.createInstance(propertyName);
          arr.push(hType);
        }
        return arr;
      }
    },
    cleaningEnabled: function() {
      if(this.stepValues.cleaningEnabled) {
        return true
      }
      return false
    },
    editRoomButton: function() {
      if (this.config.editRoomButton) {
        return this.config.editRoomButton;
      }
      return "Rediger";
    }
  },
  mounted: function() {
    if(this.protocol.related_protocol) {
      if(this.protocol.related_protocol.steps.rooms.saved_values.roomList && this.stepValues.roomList.length == 0) {
        let roomList = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.rooms.saved_values.roomList))
        for(let room in roomList) {
          if(roomList[room].type.stateQuestions.questions) {
            for(let q in roomList[room].type.stateQuestions.questions) {
              roomList[room].type.stateQuestions.questions[q].relatedValue = roomList[room].type.stateQuestions.questions[q].value
              roomList[room].type.stateQuestions.questions[q].value = null
              roomList[room].type.stateQuestions.questions[q].relatedComment = roomList[room].type.stateQuestions.questions[q].comment
              roomList[room].type.stateQuestions.questions[q].comment = null
            }
          }
          if(this.stepValues.cleaningEnabled) {
            if(roomList[room].type.cleanQuestions.questions) {
              for(let q in roomList[room].type.cleanQuestions.questions) {
                roomList[room].type.cleanQuestions.questions[q].relatedValue = roomList[room].type.cleanQuestions.questions[q].value
                roomList[room].type.cleanQuestions.questions[q].value = null
                roomList[room].type.cleanQuestions.questions[q].relatedComment = roomList[room].type.cleanQuestions.questions[q].comment
                roomList[room].type.cleanQuestions.questions[q].comment = null
              }
            }     
          }
          if(roomList[room].images) {
            roomList[room].relatedImages = roomList[room].images
            roomList[room].images = []
          }
          roomList[room].active_tab = 'tab-condition'
          roomList[room].edited = false
        }
        this.stepValues.roomList = roomList
        this.updateFields();
      }
    }
  },
  methods: {
    deleteRoom: function(i) {
      this.stepValues.roomList.splice(i, 1);
      this.updateFields();
      store.commit("saveProtocolToServer", "");
    },
    editRoom: function(room) {
      this.selectedRoom = room;
      this.editRoomDialog = true;
    },
    openEditRoomDialog: function() {
      this.selectedRoom = null;
      let newRoom = new RoomObject("Bedroom");
      this.stepValues.roomList.push(newRoom);
      this.selectedRoom = newRoom;
      this.updateFields();
      this.editRoomDialog = true;
    },
    closeEditRoomDialog: function(success = true) {
      this.updateFields();
      this.editRoomDialog = false;
      if(success) {
        this.selectedRoom.edited = true
      } else {
        this.selectedRoom.edited = false
      }
      store.commit("saveProtocolToServer", "");
    },
    selectHouseType: function(e) {
      for (var room in e.defaultRooms) {
        let newRoom = new RoomObject(e.defaultRooms[room].type.id);
        this.stepValues.roomList.push(newRoom);
      }
      store.commit("saveProtocolToServer", "");
    },
    error: function(message) {
      this.$emit("error", message)
    },
    next: function() {
      if(this.config.imageCommentRequired) {
        for(let i in this.stepValues.roomList) {
          for(let image in this.stepValues.roomList[i].images) {
            if(!this.stepValues.roomList[i].images[image].comment) {
              this.$emit("error", "Alle bilder av avvik må kommenteres")
              return false
            }
          }
        }
      }
      this.$emit("next-page");
    }
  }
};
</script>

